module.exports = __webpack_public_path__ + "img/brillo-amarillo.59212aa4.png";